// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__395q5","title":"AfterFrontImage_title__2D5QQ"};